import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 40px 0px 20px 0px;

  @media (max-width: 768px) {
    padding: 24px 0 20px;
  }
`

export const PageCard = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 24px 16px 16px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(31, 52, 77, 0.08);
`

export const UsersHeader = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 520px) minmax(0, 1fr);
  align-items: center;
  gap: 24px;
  margin: 0 0 24px;

  h2 {
    margin: 0;
    justify-self: start;
    white-space: nowrap;
    font-size: 24px !important;
    line-height: 1.2;
  }

  h4 {
    margin: 0;
    justify-self: start;
    white-space: nowrap;
  }

  > *:nth-child(2) {
    position: absolute;
    left: 50%;
    width: min(520px, 40%);
    transform: translateX(-50%);
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 12px;

    h2,
    > *:nth-child(2) {
      position: static;
      justify-self: stretch;
      width: 100%;
      transform: none;
    }
  }
`

export const SearchWrapper = styled.div`
  width: 100%;
  justify-self: center;
`

export const DashboardContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0px 40px 0px;

  @media (max-width: 992px) {
    margin: 24px 0 32px;
  }
`

interface IContainerItem {
  showDivider?: boolean
  highlight?: boolean
}

export const ContainerItem = styled.div<IContainerItem>`
  border-right: ${({ showDivider, highlight }) => (showDivider && !highlight ? '1px solid #E5E5E5' : 'none')};
  border-left: ${({ showDivider, highlight }) => (showDivider && !highlight ? '1px solid #E5E5E5' : 'none')};
  background: ${({ highlight }) => (highlight ? 'linear-gradient(135deg, #C6016B 0%, #2D749C 100%)' : 'transparent')};
  border-radius: ${({ highlight }) => (highlight ? '10px' : '0')};
  min-height: ${({ highlight }) => (highlight ? '64px' : 'auto')};
  padding: 0px 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
  text-align: left;

  h2 {
    display: block !important;
    flex: 0 0 44px;
    min-width: 44px;
    margin: 0;
    color: #2D749C;
    text-align: center;
  }

  p {
    margin: 0;
    max-width: 190px;
    text-align: center;
    line-height: 1.45;
  }

  @media (max-width: 768px) {
    width: 100%;
    border-left: none;
    border-right: none;
    border-top: ${({ showDivider }) => (showDivider ? '1px solid #E5E5E5' : 'none')};
    border-bottom: ${({ showDivider }) => (showDivider ? '1px solid #E5E5E5' : 'none')};
    padding: 16px 0;

    h2 {
      min-width: 0;
    }
  }
`

interface IRow {
  width?: string
  height?: string
  margin?: string
  padding?: string
  justifyContent?: string
  alignItems?: string
}

export const Row = styled.div<IRow>`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || 'auto'};
  margin: ${({ margin }) => margin || '0px'};
  padding: ${({ padding }) => padding || '0px'};
  display: flex;
  flex-direction: row;
  justify-content: ${({ justifyContent }) => justifyContent || 'space-between'};
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};

  @media (max-width: 768px) {
    height: auto;
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
`

export const VerticalDivider = styled.div`
  width: 1px;
  height: 100%;
  background-color: #c2c2c2;
`
export const TextCancel = styled.p`
  font-family: 'Public Sans';
  font-style: normal;
  font-weight: 700;
  color: #2d749c;
  cursor: pointer;
`

interface IProps {
  width?: string
  height?: string
  maxHeigth?: string
  padding?: string
  margin?: string
  justifyContent?: string
  alignItems?: string
  float?: string
  alignSelf?: string
  maxWidth?: string
  backgroundColor?: string
  shadow?: string
  flexDirection?: string
}

export const BlueContainer = styled.div<IProps>`
  overflow: hidden;
  display: flex;
  align-self: ${(props) => (props.alignSelf ? props.alignSelf : 'center')};
  width: ${(props) => (props.width ? props.width : '100%')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
  height: ${(props) => (props.height ? props.height : '100%')};
  max-height: ${(props) => (props.maxHeigth ? props.maxHeigth : '100%')};
  margin: ${(props) => (props.margin ? props.margin : '0')};
  padding: ${(props) => (props.padding ? props.padding : '10px')};
  justify-content: ${(props) => (props.justifyContent ? props.justifyContent : 'flex-start')};
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'flex-start')};
  float: ${(props) => (props.float ? props.float : 'none')};
  flex-direction: ${(props) => (props.flexDirection ? props.flexDirection : 'column')};
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'rgb(45, 116, 156)')};
  box-shadow: ${(props) => (props.shadow ? props.shadow : '0px 2px 10px rgba(0, 0, 0, 0.1)')};
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: scale(1.02);
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 20px 20px 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    margin: 0;
    width: 100%;
  }
`

export const TextBoldViolet = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-size: 0.95rem;
  font-style: normal;
  font-weight: 700;
  color: #c6016b;
  text-align: center;
  padding: 10px 32px;
  border-radius: 24px;
  border: 1px solid #c6016b;
  cursor: pointer;
  margin: 0;
`

export const TextBoldBlue = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 0.95rem;
  color: #2d749c;
  cursor: pointer;
  text-align: center;
  margin-right: 60px;
  padding: 10px 32px;
  border-radius: 24px;
  border: 1px solid #2d749c;

  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 0;
  }
`

export const ActionContainer = styled.div``

interface IStateButtonProps {
  backgroundColor: string
  color: string
}

export const StateButton = styled.button<IStateButtonProps>`
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
  border: none;
  border-radius: 33px;
  padding: 6px 20px;
  font-size: 16px;
  font-weight: 400;
  min-width: 100px;
  text-align: center;
  font-family: 'Public Sans', sans-serif;
`
